module.exports = __webpack_public_path__ + "img/Play.svg.c915313a.webp";